import React from 'react';
import { X_icon } from '../Common/SvgIcon/CommonSvgIcons';
import styled from 'styled-components';
const SVGDiv = styled.span`
& > svg {
    width:18px;
    height:18px
}
`;

const XIconComp = ({style}) => {
    return (
        
    <SVGDiv style={style}>{X_icon}</SVGDiv>
    );
};


export default XIconComp;